require('jquery-ui/ui/widgets/slider.js');
import Chart from 'chart.js/auto';
//import AutoNumeric from 'autonumeric';

var loadTimeout = false;

function get_offers_history(){
		$.ajax({
			data: $("#frm-filters").serialize(),
			url: baseUrl+'/get_offers_history',
			type: "post",
			dataType: "json",
			success: function ($offers) {
				
				var labelsMonth = $offers['history_months'];
				var labelsDates = $offers['history_dates'];
				var maxdatapoints = $offers['history_max_prices'];
				var mindatapoints = $offers['history_min_prices'];
				var avgdatapoints = $offers['history_avg_prices'];
				var minPrice = 0;
				var maxPrice = $offers['max_price'];
				var deviceId = $offers['device_id'];
				
				if ($(window).width()<991) var displayY=false;
				else var displayY=true;
				
				var canvas = document.getElementById("offersChart");
				var ctx = canvas.getContext("2d");
									
				var gradientMax = ctx.createLinearGradient(0, 0, 0, 450);
				gradientMax.addColorStop(0, 'rgba(0, 91,167, 0.5)');
				gradientMax.addColorStop(0.5, 'rgba(0, 91,167, 0.25)');
				gradientMax.addColorStop(1, 'rgba(0, 91,167, 0)');
									
				var gradientMin = ctx.createLinearGradient(0, 0, 0, 450);
				gradientMin.addColorStop(0, 'rgba(119, 181, 254, 0.5)');
				gradientMin.addColorStop(0.5, 'rgba(119, 181, 254, 0.25)');
				gradientMin.addColorStop(1, 'rgba(119, 181, 254, 0)');
									
				var curMonth;
								
				var data = {
				  labels: labelsMonth,
				  datasets: [
					{
						label: 'Prix + haut',
						data: maxdatapoints,
						borderColor: "#005ba7",
						backgroundColor:gradientMax,
						fill: false,
						cubicInterpolationMode: 'default',
						tension: 0.4,
						pointRadius:0,
					},
					{
						label: 'Prix moyen',
						data: avgdatapoints,
						borderColor: "#2c75ff",
						backgroundColor:gradientMin,
						fill: true,
						cubicInterpolationMode: 'default',
						tension: 0.4,
						pointRadius:0,
					}								
						
					]
				};
				var graphSaved = false;						
				var config = {
									  type: 'line',
									  data: data,
									  options: {
										  animation: {
											onComplete: function () {
												if (graphSaved==false){
													$.ajax({
														url: baseUrl+"/save_graph",
														type:"POST",
														data:{
															device_id: deviceId,
															image_base_64: myChart.toBase64Image(),
															
														},
														success:function(response){
															graphSaved=true;
														  
														}
													});	
												}
												
											  },
											},
										responsive: true,
										maintainAspectRatio: false,
										interaction: {
										  intersect: false,
										},
										plugins: {
										  legend: {
											position: 'bottom',
											align: 'left',
											labels:{
												usePointStyle: true,
												pointStyle: 'line',
											},
										  },
											tooltip: {
												callbacks: {
												  label: function(context) {											
													let label = labelsDates[context.dataIndex]["day"];
													
													if (label) {
													  label += ': ';
													}
													if (context.parsed.y !== null) {
													  label += new Intl.NumberFormat('fr-FR', {
														style: 'currency',
														currency: 'EUR'
													  }).format(context.parsed.y);
													}
													return label;
												  }
												}
										  },
										},
										scales: {
										  x: {
											grid: {
											  display: false
											},
											display: true,
											title: {
											  display: true
											},
											ticks: {
												display: true,
												autoSkip: false,
												callback: function(label, index) {
													
													if (labelsMonth[index]!=curMonth) {												
														curMonth =labelsMonth[index];
														return labelsMonth[index];												
													}
													else return "";
													
												}
											  }
										  },
										  y: {
											grid: {
											  display: false
											},
											display: true,
											title: {
											  display: displayY,
											  text: 'Prix (€)'
											},
											suggestedMin: minPrice,
											suggestedMax: maxPrice,
										  },
										  
										}
									  },
									};
					
							var  myChart = new Chart(ctx, config);
				
			},
			error: function (data) {
				
			}
		});
	}
	

$(document).ready(function () {
	
	function setNavbar(){
		if ($(window).scrollTop()) $('.navbar').addClass("navbar-scroll");
		else $('.navbar').removeClass("navbar-scroll");
	}
	
	$(function(){
	  setTimeout(function(){
		loadTimeout=true;
	  }, 2000);
	});
	
	$(window).scroll(function (event) {
		
		if ($(window).width()<991 && loadTimeout && $(window).scrollTop()>$("#filters-block").height()){
			$("#filters-block").hide();
			$("#tuning").show();
			$("#offers-title").show();
		}
		
		setNavbar();		
	});
	
	setNavbar();
	
	$(function () {
		$('[data-toggle="tooltip"]').tooltip();
	})
		
	$( "body" ).on( "change", "#order-offers",function( event ) {	
		$('#order-by').val($(this).find(':selected').data('order-by'));
		$('#order-dir').val($(this).find(':selected').data('order-dir'));
		filterResults();
	});	
		
	$( "body" ).on( "click", ".filter-trigger",function( event ) {
		//04/04/2024 nouveau système de filtre
		event.preventDefault();	
		$('*[data-type="'+$(this).attr("data-type")+'"]').removeClass("btn-primary");		
		$(this).blur().addClass("btn-primary");
		$("#"+$(this).attr("data-target")).trigger('click');
		//$(this).parent().toggleClass('isselected');
	});
		
	$( "body" ).on( "change", ".filter",function( event ) {	
	
		event.preventDefault();
		//reinit price range
		$("#price-min").val(0);
		$("#price-max").val(0);	
		
		if ($(window).width()<991){			
			//Mobile view toggle filter
			if ($(this).is(':radio')) {
				var name = $(this).attr('name');
				$("[name='"+name+"']").parent().removeClass('ischecked');
			}
			$(this).parent().toggleClass('ischecked');
			
		}else{
			filterResults($(this).attr('data-action'), $(this).attr('data-target'));
		}
	});
	
	$( "body" ).on( "click", ".apply-filters",function( event ) {	
		event.preventDefault();
		//reinit price range
		//$("#price-min").val(0);
		//$("#price-max").val(0);
		filterResults();
	});
	
	function filterResults(action, target){
		//if target item filtered modify master filter
		if (action=='remove') $('#'+target).remove();
		if (action=='add') $('#frm-filters').append(target);
		
		$.ajax({
			data: $("#frm-filters").serialize(),
			url: baseUrl+'/get_devices',
			type: "post",
			dataType: "json",
			success: function (data) {
				show_offers(data['offers']);
			},
			error: function (data) {
				
			}
		});
	}
	
	function show_offers(data, noScroll){
		
		$("#offers_block").html(data);
		$("#offers_block").show();
		$('[data-toggle="tooltip"]').tooltip();
		initPriceRange();

		$("#offers-title").show();
		if ( $("#graph-image").length ) get_offers_history();
		enable_tuning();
				
		//if (!noScroll) scrollTo("#offers"); removed 13/10 not needed
	}
	
	
	function enable_tuning(){
		
		//$(".no-tuning").show();	AR removed 29/10
		
		if ($(window).width()<991){
			$(window).scrollTop(0);
			$("#filters-block").hide();
			$("#tuning").show();
			$(".navbar").show();
		}
		
		$("#dropdowns").removeClass( "no-modal");
		$("#dropdowns #close-tuning-wrapper").show();
	}
	
	function initPriceRange(){
				
		var initialPriceMin = parseInt($( "#initial-price-min" ).val());
		var initialPriceMax = parseInt($( "#initial-price-max" ).val());
		
		var priceMin = parseInt($( "#price-min" ).val());
		var priceMax = parseInt($( "#price-max" ).val());
		
		$( ".price-min" ).html( priceMin );
		$( ".price-max" ).html( priceMax );
		
		$( "#price-range" ).slider({
			range: true,
			min: initialPriceMin,
			max: initialPriceMax,
			values: [ priceMin, priceMax ],
			slide: function( event, ui ) {
				$( ".price-min" ).val( ui.values[ 0 ] ).html( ui.values[ 0 ] );
				$( ".price-max" ).val( ui.values[ 1 ] ).html( ui.values[ 1 ] );
					
			}
		});
		
		if ($(window).width()>=991){
			$( "#price-range" ).on( "slidechange", function( event, ui ) {
				filterResults();
			});
		}
	}
	
	initPriceRange();
	
	$( "body" ).on( "click", ".select-capacite",function( event ) {			
		event.preventDefault();			
		
		$("#capacite").val($(this).attr('data-capacite'));
		$("#capacites").hide();
		$("#states").show();
	});
	
	$( "body" ).on( "click", ".select-condition",function( event ) {			
		event.preventDefault();	
		
		$("#condition").val($(this).attr('data-condition'));
		getDevicesOffers();
	});
		
	$("body").on('click', '.add-favorite', function(event){
		event.preventDefault(); 
		$.ajax({
			url: baseUrl+"/add_to_favorites",
			type:"POST",
			data:{
				offer_id: $(this).attr('data-offer-id'),
			},
			success:function(response){
				console.log(response);
			  
			},
			 statusCode: {
				200: function() {
				  $.notify("L'offre a bien été ajoutée à vos favoris.", "info");
				},
				401: function() {
				  $("#loginModal").modal('show');
				}
			 },
		});
	});
	
	/*
	new AutoNumeric('#alert-price-wish', 
			{
				currencySymbol: "€",
				currencySymbolPlacement: "s",
				decimalCharacter: ",",
				 digitGroupSeparator: ".",
			}
		);*/
	
	$("body").on('click', '.add-alert', function(event){
		event.preventDefault(); 
		
		$("#alert-price-wish").val("");
		$("#alert-offer-id").html($(this).attr('data-offer-id'));
		$("#alert-current-price").html($(this).attr('data-price')+' €');
		$("#alert-device").html($(this).attr('data-device'));
		$("#alert-condition").html($(this).attr('data-condition'));
		$("#alertModal").modal('show');
	});
	
	$("body").on('click', '#add-alert-action', function(event){
		event.preventDefault(); 
		$.ajax({
			url: baseUrl+"/add_to_alerts",
			type:"POST",
			data:{
				offer_id: $("#alert-offer-id").html(),
				condition: $("#alert-condition").html(),
				price_wish:$("#alert-price-wish").val().replace(/[^\d,-]/g, '').replace(",", '.'),
			},
			success:function(response){
				console.log(response);
			  
			},
			 statusCode: {
				200: function() {
					$("#alertModal").modal('hide');
					$.notify("L'alerte a bien été ajoutée.", "info");
				},
				401: function() {
					$("#alertModal").modal('hide');
					$("#loginModal").modal('show');
				}
			 },
		});
	});
		
	function scrollTo(id){
		if ($(id+"-desktop-anchor").length){
			$('html,body').animate({
				scrollTop: $(id+"-desktop-anchor").offset().top - $(".navbar").height() - 150
			}, 'slow');			
		}
		if ($(id+"-mobile-anchor").length){
			$('html,body').animate({
				scrollTop: $(id+"-mobile-anchor").offset().top - $(".navbar").height()
			}, 'slow')
		}
	}
		
	$("body").on('click', '.toggle-filter', function(event){
		if ($(this).is(':radio')) {
			var name = $(this).attr('name');
			$("[name='"+name+"']").parent().removeClass('ischecked');
		}
		$(this).parent().toggleClass('ischecked');
	});
	
	$("body").on('click', '.select-category', function(event){
		event.preventDefault();	
		$('#category_id').val($(this).attr('data-id'));
		$('#brand_id').prop("disabled",false);
		
		if($('#brand_id').val()!=null) get_groups_by_brand();		
	});
	
	$("body").on('click', '.modify-filters', function(event){
		event.preventDefault();	
		$(window).scrollTop(0); 
		$("#dropdowns").hide();
		$("#filters-block").show();
		if ($(window).width()<991) $("#offers-title").hide();
		$("#tuning").hide();
	});
	
	$("body").on('click', '.close-tuning', function(event){
		event.preventDefault();	
		
		$(".no-tuning").show();
		$("#offers").css("background-color", "#f8fafd");
		$("#offers_block").show();
		$("#dropdowns").hide();
		$("#filters-block").hide();
		
	});
	
	$( "body" ).on( "click", ".load-device",function( event ) {
		window.location.href = baseUrl+'/get_offers_by_device?device_id='+$(this).attr('data-device-id');
	});
	
	$("body").on('click', '.pill-redirect', function(event){
		//Mobile view redirect on click
		if ($(window).width()<991) window.location = $(this).attr('data-target');
	});
	
	$("body").on('click', '.custom-paginate', function(event){
		event.preventDefault();
		
		//this is to allow infinite pagination
		var currentPage = parseInt($(this).attr('data-page'));
		$(this).remove();
		$(".chart-wrapper").remove();
				
		var fd = new FormData();
		fd.append("offers_only", 1);
		var other_data = $('#frm-filters').serializeArray();
		$.each(other_data,function(key,input){
			if (input.name!='page') fd.append(input.name,input.value);
			else fd.append('page', currentPage+1);
		});
				
		$.ajax({
			data: fd,
			url: baseUrl+'/get_devices',
			type: "post",
			dataType: "json",
			processData: false,
			contentType: false,
			success: function (data) {
				//show_offers(data['offers']);
				
				console.log(data);
				
				$("#offers_list").append(data['offers']);
				if ( $("#graph-image").length ) get_offers_history();
				
			},
			error: function (data) {
				
			}
		});
				
	});
	
	/*
	setTimeout(()=> {
		$(".loading").toggle();
		$("#tuning").show();
		$("#offers-title").show();
    }
    ,2000);
	*/
		
	$("body").on('click', '.mobile-custom-paginate', function(event){
		event.preventDefault();
		$(this).remove();
		$(".first").show();
		$(".standard-custom-paginate").show();
	});
		
	
	
	/* removed 18/07/2024
	const setAsyncTimeout = (cb, timeout = 0) => new Promise(resolve => {
		setTimeout(() => {
			cb();
			resolve();
		}, timeout);
	});
	
	// await them in an async function
	const delayOffresAsync = async () => {
		await setAsyncTimeout(() => {
			$(".loading").toggle();
			$("#tuning").show();
			$("#offers-title").show();
		}, 2000);
	};

	delayOffresAsync();	
	*/
	
	$(".loading").toggle();
	$("#tuning").show();
	$("#offers-title").show();
		
});

window.onload = function () {
	if ( $("#graph-image").length ) {
		$("#graph-image").attr("src", $("#graph-image").attr("data-src"));	//lazy load image backup graph
		get_offers_history();
	}
};

